import { render, staticRenderFns } from "./filter_allfavoris.vue?vue&type=template&id=6ed80736"
import script from "./filter_allfavoris.js?vue&type=script&lang=js&external"
export * from "./filter_allfavoris.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports